<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <RouterLink
        class="bg-primary h-full flex items-center justify-center"
        style="width: 35vw"
        to="/"
        aria-label="Visit homepage"
      >
        <VuesticLogo :height="105" is-white start="#FFF" />
      </RouterLink>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
      <div class="absolute top-4 right-4">
        <LanguageSelector />
      </div>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <div class="flex justify-between items-center">
          <RouterLink class="py-4" to="/" aria-label="Visit homepage">
            <VuesticLogo class="mb-2" start="#0E41C9" />
          </RouterLink>
          <LanguageSelector />
        </div>
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <RouterView />
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import VuesticLogo from '../components/VuesticLogo.vue'
import LanguageSelector from '../components/LanguageSelector.vue'

const breakpoint = useBreakpoint()
</script>
